// extracted by mini-css-extract-plugin
export default {"main":"profile-page-module_main-GdL5Q","profileInfo":"profile-page-module_profileInfo-Smm_A","profileForm":"profile-page-module_profileForm-LcPa1"};